import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import logo from '../assets/logo.png'
import { baseURL2 } from '../helper/helper'
import { MapPin, Phone, Mail } from 'lucide-react'

export default function Footer() {
    const { madarsa } = useSelector((state) => state.reducer || {});

    const navLinks = [
        { name: 'Home', path: '/' },
        { name: 'About', path: '/about' },
        { name: 'Institutions', path: '/institution' },
        { name: 'Work', path: '/our-work' },
        { name: 'Online Lesson', path: '/online-class' },
        { name: 'Contact', path: '/contact' },
        { name: 'Donation', path: '/donation' },
    ];

    return (
        <footer className="bg-primary/5 border-t border-primary/10 pt-16 pb-8 text-gray-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
                {/* Brand & Mission */}
                <div className="flex flex-col gap-4">
                    <Link to="/" className="flex items-center gap-3 mb-2">
                        <img src={baseURL2 + madarsa?.logo || logo} alt="Logo" className="h-10 w-auto" />
                        <span className="text-lg font-bold text-primary leading-tight">
                            {madarsa?.name || "Faiz ul Hasnain"}
                        </span>
                    </Link>
                    <p className="text-gray-600 text-sm leading-relaxed">
                        Nafrat Kisi Se Nahin, <br />
                        <span className="text-secondary font-medium">Mohabbat Sabke Liye.</span>
                    </p>
                </div>

                {/* Quick Links */}
                <div>
                    <h4 className="text-sm font-bold uppercase tracking-widest text-primary mb-6 border-b border-primary/10 pb-2">
                        Navigation
                    </h4>
                    <ul className="space-y-3">
                        {navLinks.map((link) => (
                            <li key={link.name}>
                                <Link to={link.path} className="text-gray-600 text-sm hover:text-secondary transition-colors">
                                    {link.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Core Pillars */}
                <div>
                    <h4 className="text-sm font-bold uppercase tracking-widest text-primary mb-6 border-b border-primary/10 pb-2">
                        Core Pillars
                    </h4>
                    <ul className="space-y-3 text-gray-600 text-sm">
                        <li>Aqeeda (Faith)</li>
                        <li>Taleem (Education)</li>
                        <li>Technology (Digital)</li>
                        <li>Tijarat (Business)</li>
                        <li>Hifazat (Protection)</li>
                    </ul>
                </div>

                {/* Contact Information */}
                <div>
                    <h4 className="text-sm font-bold uppercase tracking-widest text-primary mb-6 border-b border-primary/10 pb-2">
                        Reach Out
                    </h4>
                    <div className="space-y-4">
                        <div className="flex items-start gap-3">
                            <MapPin className="text-secondary w-4 h-4 shrink-0 mt-0.5" />
                            <p className="text-gray-600 text-sm">{madarsa?.address || 'Nashik, Maharashtra'}</p>
                        </div>
                        <div className="flex items-center gap-3 text-gray-700 text-sm">
                            <Phone className="text-secondary w-4 h-4 shrink-0" />
                            {madarsa?.contact_number || '+91 91722 71113'}
                        </div>
                        <div className="flex items-center gap-3 text-gray-700 text-sm">
                            <Mail className="text-secondary w-4 h-4 shrink-0" />
                            {madarsa?.email || 'info@faizulhasnain.org'}
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 border-t border-primary/10 flex flex-col md:flex-row items-center justify-between gap-4">
                <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4 text-center md:text-left">
                    <p className="text-gray-500 text-xs">
                        &copy; {new Date().getFullYear()} {madarsa?.name || "Faiz ul Hasnain Foundation"}. All Rights Reserved.
                    </p>
                    <span className="hidden md:block text-gray-300">|</span>
                    <p className="text-gray-500 text-xs font-medium">Made with ❤️ by <a href="https://nerdtech.in" target="_blank" rel="noopener noreferrer" className="text-secondary hover:text-primary transition-colors">Nerdtech</a></p>
                </div>
                <div className="flex gap-4">
                    <a href="https://www.facebook.com/share/1C82RzTKfD/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">Facebook</a>
                    <a href="https://www.instagram.com/faizul_hasnain_foundation?utm_source=qr&igsh=MWk5d2p4ODZ4OTcweQ==" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">Instagram</a>
                    <a href="https://youtube.com/@faizulhasnainfoundation?si=ip_TUH9wepVvxycL" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">YouTube</a>
                </div>
            </div>
        </footer>
    )
}
